var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getI18nBundle } from '@ui5/webcomponents-base/dist/i18nBundle.js';
import { attachLanguageChange, detachLanguageChange } from '@ui5/webcomponents-base/dist/locale/languageChange.js';
import { I18nContext } from '@ui5/webcomponents-react-base';
import React, { useCallback, useEffect, useReducer, useRef } from 'react';
const bundleReducer = (currentBundles, action) => {
    return Object.assign(Object.assign({}, currentBundles), action.payload);
};
export function I18nProvider({ children }) {
    var _a;
    const [i18nBundles, setI18nBundles] = useReducer(bundleReducer, {});
    const localBundles = useRef({});
    const isSyncedWithWindow = useRef(false);
    if (!isSyncedWithWindow.current && typeof window !== 'undefined') {
        (_a = window['@ui5/webcomponents-react']) !== null && _a !== void 0 ? _a : (window['@ui5/webcomponents-react'] = {});
        window['@ui5/webcomponents-react'].I18nContext = I18nContext;
        isSyncedWithWindow.current = true;
    }
    const setI18nBundle = useCallback((name, bundle) => {
        setI18nBundles({
            payload: {
                [name]: bundle
            }
        });
        localBundles.current[name] = bundle;
    }, []);
    useEffect(() => {
        let isMounted = true;
        const fetchI18n = () => __awaiter(this, void 0, void 0, function* () {
            const bundles = yield Promise.all(Object.keys(localBundles.current).map((bundleName) => getI18nBundle(bundleName)));
            const bundleMap = bundles.reduce((acc, bundle) => (Object.assign(Object.assign({}, acc), { [bundle.packageName]: bundle })), {});
            if (isMounted) {
                setI18nBundles({
                    payload: bundleMap
                });
            }
        });
        attachLanguageChange(fetchI18n);
        return () => {
            isMounted = false;
            detachLanguageChange(fetchI18n);
        };
    }, []);
    return (React.createElement(I18nContext.Provider, { value: {
            i18nBundles,
            setI18nBundle
        } }, children));
}
